import { useContext, useEffect, useRef } from "react";
import { format, parse } from "date-fns";

import useFetch from "../useFetch";
import { ToastContext } from "src/context/toastContext";

import { AddCaseAPIResProps, AddCaseProps } from "src/pages/addCase/types";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastTypes } from "src/types";
import { PracticeDropdownResponse } from "src/components/caseStepTwo/types";
import { LoaderContext } from "src/context/loaderContext";
import { AuthContext } from "src/context/authContext";
import { useNavigate } from "react-router-dom";



/**
 * @AddNewCase form handling for case data submission
 * @fourth case submit handler
 */
const useCaseSubmitFunc = (practiceDropdownApiRes?: PracticeDropdownResponse, setPrecertInfoModal?: (value: { isModalVisible: boolean; caseId: number; precertId: number; }) => void) => {
  const { showToast } = useContext(ToastContext)
  const { setLoader, hideLoader } = useContext(LoaderContext)
  const { new_baa_user_1_2 } = useContext(AuthContext)
  const indicationVal = useRef<string>("")
  const navigate = useNavigate();



  const { loading: addCaseLoading, error: addCaseError, data: addCaseData, mutate: addNewCase } =
    useFetch<AddCaseAPIResProps>(APIEndpoints.ADD_NEW_CASE);

  useEffect(() => {
    if (addCaseData || addCaseError) {
      hideLoader()

      if (addCaseData && addCaseData.success === true) {
        showToast([`Your request submitted successfully!`], ToastTypes.SUCCESS);
        localStorage.removeItem('newCase');
        // console.log("here we are!!! ")
        // console.log("About to be redirected")
        if (indicationVal.current.toLowerCase() === "other") {
          navigate('/cases')
        } else {
          setPrecertInfoModal?.({ isModalVisible: true, caseId: addCaseData.case_id, precertId: 0 });
        }
        // if(addCaseData.redirect === "precert_edit") {
        //    navigate('/cases')
        //  // navigate(`/cases/${addCaseData.case_id}/precerts/${addCaseData.precert_id}/edit`);
        // } else {
        //   navigate('/cases')
        // }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addCaseData, addCaseError]);

  /** @fourth */
  const caseDataSubmission = (values: AddCaseProps) => {
    setLoader();
    const prescription_attributes_attributes = [
      // {
      //   name: "scheduled_date_of_service",
      //   value: `${format(new Date(), 'yyyy/MM/dd')}T${format(new Date(), 'hh:mm a')}`,
      // },
      {
        name: "indication",
        value: values.prescription_attributes.indication
      }
    ];

    const { indication, ...required_prescription_attributes } = values.prescription_attributes;
    const { reinvestigation, outreach, pcc_outreach, ...required_patient_attributes } = values.patient_attributes;
    const patient_attributes = [
      {
        name: "reinvestigation", value: reinvestigation ? 1 : 0
      },
      {
        name: "outreach", value: (indication ==="Other" || indication === "PHN") ? 0 : outreach ? 1 : 0
      },
      (typeof new_baa_user_1_2 === "boolean" && new_baa_user_1_2 === false ? 
        {
          name: "pcc_outreach", value: (indication ==="Other" || indication === "PHN") ? 0 : pcc_outreach ? 1 : 0
        }
        : {}
      )
    ]

    const trimmed_shipments_attributes = [];
    if (values.shipments_attributes.length > 0 && values.shipments_attributes[0].ship_to) {
      if (values.shipments_attributes[0].ship_to === "Other" && values.shipments_attributes && values.shipments_attributes.length > 0) {
        trimmed_shipments_attributes.push({
          ...values.shipments_attributes[0],
          ship_to: "Other",
        });
      } else if (values.shipments_attributes[0].ship_to === "Provider Office") {
        const practiceData = practiceDropdownApiRes && practiceDropdownApiRes.data && practiceDropdownApiRes.data.length > 0 &&
          practiceDropdownApiRes.data.find((prac) => prac.id === values.doctor_attributes.practice_id)

        if (practiceData)
          trimmed_shipments_attributes.push({
            ship_to: values.shipments_attributes[0].ship_to,
            // ship_to_street: practiceData.address.street,
            // ship_to_suite: practiceData.address.suite || "",
            // ship_to_city: practiceData.address.city,
            // ship_to_state: practiceData.address.state,
            // ship_to_zip: practiceData.address.zip,
          })
      } else if (values.shipments_attributes[0].ship_to === "Hospital Outpatient Dept") {
        trimmed_shipments_attributes.push({
          ship_to: values.shipments_attributes[0].ship_to,
          ship_to_street: values.patient_attributes.address.street,
          ship_to_suite: values.patient_attributes.address.suite || "",
          ship_to_city: values.patient_attributes.address.city,
          ship_to_state: values.patient_attributes.address.state,
          ship_to_zip: values.patient_attributes.address.zip,
        })
      }
    }

    // const update_diagnosis_code = values.prescription_attributes.diagnosis_code.map((item) => (item as unknown as { value: string; label: string; }).value).join(", ")

    const newValues = {
      ...values,
      procedures_attributes: [
        { cpt_code: values.procedure_attributes.cpt_code }
      ],
      prescription_attributes: {
        ...required_prescription_attributes,
        diagnosis_code: values.prescription_attributes.diagnosis_code.map((item) => item.split(" - ")[0]).join(","),
        drug_name: "Qutenza (Pack Size 1)",
        // drug_id: DEFAULT_DRUG_ID,
        written_date: values.prescription_attributes.written_date ? 
          format(parse(values.prescription_attributes.written_date, "MM/dd/yyyy", new Date()), "dd/MM/yyyy") :
          format(new Date(), "dd/MM/yyyy"),
        prescription_attributes_attributes,
      },
      insurances_attributes: values.insurances_attributes?.map((insurance, index) => {
        let insurance_type = null;
        if (insurance.plan_type?.toLowerCase()?.replace(/\s/g, "") === "commercialmarketplace") insurance_type = "commercial_marketplace"
        else if (insurance.plan_type?.toLowerCase()?.replace(/\s/g, "") === "commercialplan") insurance_type = "commercial"
        insurance.insurance_priority = index;
        insurance.plan_type = insurance_type ?? insurance.plan_type;
        return insurance;
      }),
      patient_attributes: {
        ...required_patient_attributes,
        patient_attributes_attributes: patient_attributes,
      },
      patient_firstlastname: `${values.patient_attributes.firstname.trim()} ${values.patient_attributes.lastname.trim()}`,
      patient_fullname: `${values.patient_attributes.firstname.trim()} ${values.patient_attributes.middlename?.trim()} ${values.patient_attributes.lastname.trim()}`,
      patient_dob: values.patient_attributes.dob,
      shipments_attributes: trimmed_shipments_attributes,
    };

    const { procedure_attributes, ...trimmedcaseValues } = newValues;
    indicationVal.current = values.prescription_attributes.indication;
    // console.log("newValues.....",trimmedcaseValues)
    addNewCase({ case: trimmedcaseValues });
  };

  return {
    addCaseLoading,
    caseDataSubmission
  }
}

export default useCaseSubmitFunc
